export default __webpack_public_path__ + "static/media/teams.4541ca9e.svg";